"use client"

import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Alert,
  CircularProgress,
  Box
} from '@mui/material';
import { Iconify } from '../iconify';
import axios from 'axios';
import { endpoints } from '@/utils/axios';

export function DeleteDataButton() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(endpoints.meta.deleteDataFacebook, {}, {
        headers: { Authorization: `Bearer ${sessionStorage.jwt_access_token}` }
      })

      const data = response;
      console.log("response: ", data);

      setSuccess(true);

      setTimeout(() => {
        window.location.reload();
      }, 2000);

    } catch (err) {
      setError(err.message || 'Error deleting data');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setOpen(false);
      setError('');
      setSuccess(false);
    }
  };

  // if (!session) {
  //   return (
  //     <Alert severity="info" sx={{ mt: 3 }}>
  //       To delete your data, please log in to your account first.
  //     </Alert>
  //   );
  // }

  return (
    <Box sx={{ mt: 4 }}>
      <Button
        variant="contained"
        color="error"
        size="large"
        startIcon={<Iconify icon="solar:trash-bin-2-bold" />}
        onClick={() => setOpen(true)}
        sx={{ minWidth: 200 }}
      >
        Delete My Data
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Delete Data
        </DialogTitle>

        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              Your data deletion request completed successfully. Refreshing...
            </Alert>
          )}

          {!success && (
            <>
              <Typography variant="body1" paragraph>
                Are you sure you want to delete your data?
              </Typography>

              <Typography variant="body2" color="text.secondary" paragraph>
                This action will:
              </Typography>

              <Typography component="ul" variant="body2" color="text.secondary" sx={{ pl: 2 }}>
                <li>Permanently delete your stored personal data</li>
                <li>Remove linked content and associated metadata</li>
                <li>Stop all ongoing processing</li>
              </Typography>

              <Alert severity="info" sx={{ mt: 2 }}>
                <strong>Note:</strong> This action is irreversible and cannot be undone.
              </Alert>
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </Button>

          {!success && (
            <Button
              onClick={handleDelete}
              color="error"
              variant="contained"
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : <Iconify icon="solar:trash-bin-2-bold" />}
            >
              {loading ? 'Deleting...' : 'Delete Data'}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
}